import { Component, ViewEncapsulation, OnInit, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { Data, AppService } from '../../app.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { emailValidator, matchingPasswords } from '../../theme/utils/app-validators';


// ************************************************** RESTORE PASSWORD COMPONENT CLASS ************************************************
@Component({
  selector: 'restore-password-page',
  templateUrl: './restorePassword.component.html',
  styleUrls: ['./restorePassword.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RestorePasswordComponent implements OnInit {
  public config: SwiperConfigInterface = {};
  restorePasswordForm: FormGroup;

  constructor(public appService: AppService, public formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<RestorePasswordComponent>,
              ) { }


  // -- FUNC Ng On Init
  ngOnInit() {
    this.restorePasswordForm = this.formBuilder.group({
      'restorePasswordEmail': ['', Validators.compose([Validators.required, emailValidator])]
    });
  }


  // -- FUNC Ng After View Init
  ngAfterViewInit(){
    this.config = {
      slidesPerView: 1,
      spaceBetween: 0,         
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,        
      loop: false,
      preloadImages: false,
      lazy: true, 
      effect: "fade",
      fadeEffect: {
        crossFade: true
      }
    }
  }


  // -- FUNC Close
  public close(): void {
    this.dialogRef.close();
  }


  // -- FUNC On Restore Password Form Submit
  public onRestorePasswordFormSubmit(values: Object): void {
    
    if (this.restorePasswordForm.valid) {
      var email = values['restorePasswordEmail'];

      //console.log("FORGOT PASSWORD DATA: " + email);

      this.appService.perfromForgotPassword(email);
    }
  }
}
